import { useContext, useEffect } from "react";
import { Redirect } from "react-router-dom";
import { RulesPermissionUserContext } from "../contexts/RulesPermissionUser";

const permissionRedirect = {
    'adicionarprodutovenda':'6.1.1',
    'adicionarprodutonfce':'6.2.1.1',
    'adicionarprodutoentradanfe':'6.2.2.2',
    'adicionarprodutosaidanfe':'6.2.3.2',
    'adicionarprodutoentrada':'6.3.1',
    'listarproduto':'1.5.4',
    'listarcomplemento':'1.1.4',
    'listargrupocomplemento':'1.2.4',
    'listarfabricante':'1.3.4',
    'listarsecao':'1.4.4',
    'notaavulsa':'3.1.1',
    'inventario':'3.2.1',
    'listarcliente':'2.1.4',
    'carregaratendente':'2.2.4',
    'listarentregador':'2.3.4',
    'listarusuario':'2.4.4',
    'listarformapagamento':'4.1.4',
    'listarreceita':'4.2.4',
    'listarcontacorrente':'5.3.4',
    'listardespesa':'4.4.4',
    'listarcontaspagar':'4.5.4',
    'contaspagar':'4.5.4',
    'listarcontaspagas':'4.5.4',
    'listarcontascanceladas':'4.5.4',
    'listarcontasreceber':'4.6.4',
    'contasreceber':'4.6.4',
    'listarcontasrecebidas':'4.6.4',
    'listarcontasrecebercanceladas':'4.6.4',
    'listarfrete':'6.4.4',
    'parametro':'6.5.2',
    'listarvendas': '6.6.1',
    'venda': '6.6.1',
    'listarnotasentrada': '6.7.1',
    'entrada': '6.7.1',
    'carregarmesas': '6.8.1',
    'adicionarprodutomesa': '6.8.1',
    'dashboard': '6.10.1',
    'delivery': '6.9.4',
    'adicionarprodutodelivery': '6.9.4',
    'relevendas': '6.11.4',
    'listaretiqueta': '1.8.1',
    'listarncm': '1.6.4',
    'listarcfop': '1.7.4',
    'listarvaletroca': '4.8.4',
    'listarsangriasuprimento': '4.7.4',
    
}

export const PermissionRoutesPrimaries = ({children,rest}) => {
    const  {matchRoutePermission, setAccessDenied} = useContext(RulesPermissionUserContext);
    const {pathname} = rest.location;
    const [,path] = pathname.split('/');

    useEffect(() => {
        if(permissionRedirect[path?.toLowerCase()] && (path !== 'dashboard')){
            if (!matchRoutePermission( permissionRedirect[path?.toLowerCase()])) setAccessDenied(true);
        }

    }, [path])

    if(permissionRedirect[path?.toLowerCase()] && (path !== 'dashboard')){
        if (!matchRoutePermission(permissionRedirect[path?.toLowerCase()])) return <Redirect to={{ pathname: '/dashboard', state:{from: rest.location } }} />
    }

    return(
        children
    )

}